const ELEMENT_OPTIONS_PROPS = {
  paymentMethodCreation: 'manual',
  allowedCardBrands: ['visa', 'mastercard'],
};

export { ELEMENT_OPTIONS_PROPS };
